import React, { FC } from 'react';
import { makeStyles } from 'design-system/styles';
import { Button } from 'design-system';

import { STAGE } from '../../constants';

interface MainViewProps {
  addedwokerTeams: { primary: Array<string>; secondary: Array<string> };
  setCurrentStage: React.Dispatch<React.SetStateAction<STAGE>>;
  setAlertStatus: React.Dispatch<React.SetStateAction<{ severity: string; content: any } | null>>;
}

const MainView: FC<MainViewProps> = ({ setCurrentStage, setAlertStatus, addedwokerTeams }) => {
  const classes = useStyles();
  return (
    <div className={classes.container}>
      <div className={classes.buttonWrapper}>
        <Button
          type="info"
          onClick={() => {
            setCurrentStage(STAGE.ASSIGN_TEAM_VIEW);
            setAlertStatus(null);
          }}
        >
          assign to existing team
        </Button>
        <Button
          type="warning"
          onClick={() => {
            setCurrentStage(STAGE.CREATE_TEAM_VIEW);
            setAlertStatus(null);
          }}
        >
          create a new worker team
        </Button>
      </div>
      <div className={classes.nameContainer}>
        <div>
          <h3>primary</h3>
          <div className={classes.primaryName}>
            {addedwokerTeams.primary.map((name: string) => (
              <span key={name}>{name}</span>
            ))}
          </div>
        </div>
        <div>
          <h3>secondary</h3>
          <div className={classes.secondaryName}>
            {addedwokerTeams.secondary.map((name: string) => (
              <span key={name}>{name}</span>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

const useStyles = makeStyles({
  container: {
    width: 400,
  },

  buttonWrapper: {
    marginTop: 10,
    display: 'flex',
    margin: '5px 0',
    justifyContent: 'space-between',
    '& span': {
      fontWeight: 'bold',
      color: 'white',
    },
  },

  header: {
    '& h2': {
      display: 'flex',
      justifyContent: 'space-between',
    },
  },
  name: {
    padding: '5',
  },
  nameContainer: {
    '& > div': {
      display: 'flex',
      flexDirection: 'column',
    },
    '& span': {
      padding: '5px 8px',
      margin: 5,
      borderRadius: 20,
      color: 'white',
      alignSelf: 'baseline',
    },
  },
  primaryName: {
    borderRadius: 5,
    backgroundColor: 'var(--color-RemoGray01)',
    padding: '10px 2px',
    height: 100,
    display: 'flex',
    flexWrap: 'wrap',
    alignContent: 'start',
    '& span': {
      backgroundColor: 'var(--color-LightPeriwinkle)',
    },
  },
  secondaryName: {
    borderRadius: 5,
    backgroundColor: 'var(--color-RemoGray01)',
    padding: '10px 2px',
    height: 100,
    display: 'flex',
    flexWrap: 'wrap',
    alignContent: 'start',
    '& span': {
      backgroundColor: 'var(--color-LightMauve)',
    },
  },
});

export default MainView;
